import { Suspense } from "react";
import { RouterProvider } from "react-router-dom";
import { ClerkProvider } from "@clerk/clerk-react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { HelmetProvider } from "react-helmet-async";
import { AnalyticsProvider } from "./components/AnalyticsProvider";
import { ClerkTokenBridge } from "./components/ClerkTokenBridge";
import { CookieBanner } from "./components/CookieBanner";
import { DiscardEditsDialog } from "./components/common/DiscardEditsDialog";
import { router } from "./router";
import theme from "./theme";

// Create QueryClient instance
const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 1000 * 60 * 5, // 5 minutes
			cacheTime: 1000 * 60 * 30, // 30 minutes
			refetchOnWindowFocus: false,
		},
	},
});

// Clerk publishable key from environment
const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY || "";

function App() {
	return (
		<HelmetProvider>
			<ThemeProvider theme={theme}>
				<CssBaseline />
				<ClerkProvider publishableKey={PUBLISHABLE_KEY}>
					<QueryClientProvider client={queryClient}>
						<ClerkTokenBridge />
						<AnalyticsProvider>
							<Suspense
								fallback={
									<div className="flex min-h-screen items-center justify-center bg-[var(--bg)]">
										<div className="h-12 w-12 animate-spin rounded-full border-b-2 border-[var(--violet)]"></div>
									</div>
								}
							>
								<RouterProvider router={router} />
							</Suspense>
							<DiscardEditsDialog />
							<CookieBanner />
						</AnalyticsProvider>
					</QueryClientProvider>
				</ClerkProvider>
			</ThemeProvider>
		</HelmetProvider>
	);
}

export default App;
